import { gql } from 'graphql-request';

export const SEAT_ASSIGNMENT_FIELDS = gql`
  fragment SeatAssignmentFields on SeatAssignmentDto {
    id
    userId
    seatType
    assignedAt
    revokedAt
  }
`;

export const getOrganizationSeatAssignments = gql`
  query getOrganizationSeatAssignments {
    getOrganizationSeatAssignments {
      ...SeatAssignmentFields
    }
  }
  ${SEAT_ASSIGNMENT_FIELDS}
`;

export const assignSeat = gql`
  mutation assignSeat($input: AssignSeatInput!) {
    assignSeat(input: $input) {
      ...SeatAssignmentFields
    }
  }
  ${SEAT_ASSIGNMENT_FIELDS}
`;

export const revokeSeat = gql`
  mutation revokeSeat($input: RevokeSeatInput!) {
    revokeSeat(input: $input) {
      ...SeatAssignmentFields
    }
  }
  ${SEAT_ASSIGNMENT_FIELDS}
`;

const SeatGraphQL = {
  queries: {
    getOrganizationSeatAssignments,
  },
  mutations: {
    assignSeat,
    revokeSeat,
  },
};

export default SeatGraphQL;
